import { getIrrigationStatusColors } from 'App/Map/_utils/getIrrigationStatusColors'
import type { TIrrigationDeviceStatus } from 'App/Map/types'
import { translate } from 'i18n/i18n'

const getCurrentValuesStatusLabel = (currentValueStatus: TIrrigationDeviceStatus) => {
  switch (currentValueStatus) {
    case 'on':
      return translate.phrases.banyanApp('ON')

    case 'off':
      return translate.phrases.banyanApp('OFF')

    case 'error':
      return translate.phrases.abbreviations('Error')

    default:
      return '-'
  }
}

export const IrrigationCurrentStatusBadge = ({
  currentValueStatus,
}: {
  currentValueStatus: TIrrigationDeviceStatus
}) => {
  const statusColors = getIrrigationStatusColors(currentValueStatus)

  return (
    <div
      css={{
        border: '2px solid white',
        background: statusColors.backgroundColor,
        borderRadius: '95px',
        padding: '4px 10px',
        fontSize: 14,
        color: statusColors.color,
        minWidth: 50,
        textAlign: 'center',
      }}
    >
      {currentValueStatus ? getCurrentValuesStatusLabel(currentValueStatus).toUpperCase() : ''}
    </div>
  )
}
